<div class="d-flex flex-column flex-lg-row flex-column-fluid">
   <!--begin::Body-->
   <div class="d-flex flex-column flex-lg-row-fluid w-lg-50 p-10 order-2 order-lg-1">
      <!--begin::Form-->
      <div class="d-flex flex-center flex-column flex-lg-row-fluid">
         <!--begin::Wrapper-->
         <div class="w-lg-500px p-10">
            <router-outlet></router-outlet>
         </div>
         <!--end::Wrapper-->
      </div>
      <!--end::Form-->

      <!--begin::Footer-->
      <div class="d-flex flex-center flex-wrap px-5">
         <!--begin::Links-->
         <!-- <div class="d-flex fw-semibold text-primary fs-base">
            <a href="https://DAL-System.com/privacy-policy/" class="px-5" target="_blank">Privacy</a>

            <a href="https://DAL-System.com/#services" class="px-5" target="_blank">Services</a>

            <a href="https://DAL-System.com/contact-us/" class="px-5" target="_blank">Contact Us</a>
         </div> -->
         <!--end::Links-->
      </div>
      <!--end::Footer-->
   </div>
   <!--end::Body-->

   <!--begin::Aside-->
   <div
      class="d-flex flex-lg-row-fluid w-lg-50 bgi-size-cover bgi-position-center order-1 order-lg-2"
      [ngStyle]="{ 'background-image': 'url(./media/misc/auth-screens.jpg)' }"
   >
      <!--begin::Content-->
      <div class="d-flex flex-column flex-center py-15 px-5 px-md-15 w-100"></div>
      <!--end::Content-->
   </div>
   <!--end::Aside-->
</div>
